import { render } from "./BizUserProfile.vue?vue&type=template&id=5b646b2e"
import script from "./BizUserProfile.vue?vue&type=script&lang=js"
export * from "./BizUserProfile.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__